import { render } from "./FloatBackPage.vue?vue&type=template&id=58ade8ea&scoped=true"
import script from "./FloatBackPage.vue?vue&type=script&lang=js"
export * from "./FloatBackPage.vue?vue&type=script&lang=js"

import "./FloatBackPage.vue?vue&type=style&index=0&id=58ade8ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ade8ea"]])

export default __exports__